import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  chart: {
    // Ihre Styles hier
  },
  tooltip: {
    position: 'absolute',
    textAlign: 'center',
    width: 'auto',
    height: 'auto',
    padding: '8px',
    font: '12px sans-serif',
    background: 'lightsteelblue',
    border: '0px',
    borderRadius: '8px',
    pointerEvents: 'none',
  },
}));

export const HistPlot = ({ termArray }) => {
  const classes = useStyles();
  const chartRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(800); // Standardbreite

  useEffect(() => {
    // Ermitteln der Breite des übergeordneten Elements
    const handleResize = () => {
      if (chartRef.current) {
        setContainerWidth(chartRef.current.parentElement.offsetWidth);
      }
    };

    handleResize(); // Initiale Breite ermitteln
    window.addEventListener('resize', handleResize); // Event-Listener für Fenstergröße

    return () => {
      window.removeEventListener('resize', handleResize); // Event-Listener entfernen
    };
  }, []);

  //console.log("termArray in Hist Plot");
  //console.log(termArray);

  let dateArray = [];
  let formattedData = [];

  let scale = "day";

  if (termArray) {
    dateArray = termArray.map((item) => {
      const date = new Date(item.date).toISOString().split('T')[0];
      if (scale === "day") {
        return new Date(item.date).toISOString().split('T')[0];
      } else if (scale === "month") {
        return new Date(item.date).toISOString().split('-').slice(0, 2).join("-");
      } else if (scale === "year") {
        return new Date(item.date).toISOString().split('-')[0];
      }
    });
  }

  //console.log("dateArray");
  //console.log(dateArray);

  // Schritt 1: Häufigkeit der Strings zählen
  const frequency = dateArray.reduce((acc, date) => {
    acc[date] = (acc[date] || 0) + 1;
    return acc;
  }, {});

  // Schritt 2: Eindeutiges Array erstellen
  const uniqueArray = Object.keys(frequency);

  //console.log("Häufigkeit der Strings:", frequency);
  //console.log("Eindeutiges Array:", uniqueArray);

  // Schritt 3: Array im gewünschten Format erstellen
  formattedData = uniqueArray.map(date => ({
    date: new Date(date), // Konvertieren Sie das Datum in ein Date-Objekt
    count: frequency[date],
  }));

  //console.log("formattedData:", formattedData);

  useEffect(() => {
    // Diagramm erstellen
    const margin = { top: 20, right: 30, bottom: 75, left: 50 }; // Vergrößern Sie den unteren Rand
    const width = containerWidth - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    // Entfernen des alten SVG-Inhalts, um das Diagramm neu zu erstellen
    d3.select(chartRef.current).selectAll("*").remove();

    const svg = d3.select(chartRef.current)
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(formattedData.map(d => d.date))
      .range([0, width])
      .padding(0.1);

    const y = d3.scaleLinear()
      .domain([0, d3.max(formattedData, d => d.count)])
      .nice()
      .range([height, 0]);

    svg.append('g')
      .attr('transform', `translate(0,${height})`)
      .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%d.%m.%Y")))
      .selectAll("text")
      .attr("text-anchor", "end")
      .attr("transform", "rotate(-45)")
      .attr("dx", "-0.8em")
      .attr("dy", "0.15em");

    svg.append('g')
      .call(d3.axisLeft(y));

    // Achsentitel hinzufügen
    svg.append("text")
      .attr("text-anchor", "end")
      .attr("x", width / 2 )
      .attr("y", height + margin.top + 50)
      .text("Date");

    svg.append("text")
      .attr("text-anchor", "end")
      .attr("transform", "rotate(-90)")
      .attr("y", -margin.left + 20)
      .attr("x", -margin.top - height / 2 + 20)
      .text("New Terms");

    // Tooltip hinzufügen
    const tooltip = d3.select("body").append("div")
      .attr("class", classes.tooltip)
      .style("opacity", 0);

    svg.selectAll('.bar')
      .data(formattedData)
      .enter().append('rect')
      .attr('class', 'bar')
      .attr('x', d => x(d.date))
      .attr('y', d => y(d.count))
      .attr('width', x.bandwidth())
      .attr('height', d => height - y(d.count))
      .attr('fill', 'steelblue')
      .on("mouseover", (event, d) => {
        tooltip.transition()
          .duration(200)
          .style("opacity", .9);
        tooltip.html(`Date: ${d3.timeFormat("%Y-%m-%d")(d.date)}<br>New Terms: ${d.count}`)
          .style("left", (event.pageX + 5) + "px")
          .style("top", (event.pageY - 28) + "px");
      })
      .on("mouseout", (d) => {
        tooltip.transition()
          .duration(500)
          .style("opacity", 0);
      });

  }, [formattedData, containerWidth]);

  return (
    <div>
      <svg ref={chartRef} className={classes.chart}></svg>
    </div>
  );
};